import { Check, Save } from "lucide-react";
import * as React from "react";
import styled from "styled-components";
import { db } from "src/database/dexie";
import { useLiveQuery } from "dexie-react-hooks";

interface Props {
  date: string;
  seriesId: string;
  onSave(value: string): void;
}

type State = "pending" | "done";

export function Metric({ date, seriesId, onSave }: Props) {
  const initialValue = useLiveQuery(
    () => db.metrics.where("[seriesId+date]").equals([seriesId, date]).first(),
    [seriesId, date],
  );

  const [value, setValue] = React.useState<string | null>(null);
  const [state, setState] = React.useState<State>("pending");

  const derivedValue = value ?? initialValue?.value ?? "";

  const handleSave = () => {
    onSave(derivedValue);
    setState("done");
  };

  return (
    <>
      <Container>
        <Input
          type="number"
          step={1}
          onChange={(e) => setValue(e.target.value)}
          value={derivedValue}
        />
        <Controls>
          {(() => {
            switch (state) {
              case "pending":
                return (
                  <Button onClick={handleSave}>
                    <Save color="#999" strokeWidth={1} size={20} />
                  </Button>
                );
              case "done":
                return (
                  <Button>
                    <Check color="green" strokeWidth={2} size={20} />
                  </Button>
                );
            }
          })()}
        </Controls>
      </Container>
    </>
  );
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: var(--box-color);
`;

const Input = styled.input`
  font-size: 16px;
  flex-grow: 1;
  display: block;
  font-family: inherit;
  border: none;
  padding: 5px 8px 5px;
  background: none;
`;

const Controls = styled.div`
  padding-right: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
